var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('AppFigure',{staticClass:"hero__image",attrs:{"data":{ src: _vm.data.src, alt: _vm.data.alt },"isLazy":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }